/**
 * Common primitive types reused across schemas.
 */

export type Id = string; // UUID v4
export type Iso8601 = string; // e.g. "2026-08-01T19:30:00.000Z"
export type Email = string;
export type PhoneE164 = string; // E.164: +971501234567
export type Url = string;
export type Currency = 'AED' | 'USD' | 'GBP' | 'PKR' | 'SAR' | 'EUR' | 'INR';

/** Allowed currencies for fee + invoicing (per competitive research). */
export const SUPPORTED_CURRENCIES: readonly Currency[] = [
  'AED', 'USD', 'GBP', 'PKR', 'SAR', 'EUR', 'INR',
] as const;

/** Money amount, expressed in minor units (e.g. fils for AED, cents for USD). */
export interface Money {
  readonly amount: number;       // minor units (e.g. 12345 = 123.45)
  readonly currency: Currency;
}

/** Pagination cursor (opaque base64 string returned by the API). */
export type Cursor = string;

/** Standard list response envelope with cursor pagination. */
export interface Page<T> {
  readonly items: readonly T[];
  readonly nextCursor: Cursor | null;
  readonly total: number;          // total matching rows (not just this page)
}

export interface AuditFields {
  readonly createdAt: Iso8601;
  readonly updatedAt: Iso8601;
  readonly createdById: Id;
  readonly updatedById: Id | null;
}